import clsx from 'clsx';
import SpinnerSvg from '@/assets/icons/spinner.svg';
import s from './Loader.module.scss';

export const Loader = ({ fixed }: { fixed?: boolean }) => {
  return (
    <div className={clsx(s.loader, { [s.loader_fixed]: fixed })}>
      <SpinnerSvg />
    </div>
  );
};